import axios from 'axios';

const proofUrl = (attachmentId) => `/api/employee-expenses/proof/${attachmentId}`;

export const downloadProof = async (attachment) => {
  try {
    const res = await axios.get(proofUrl(attachment._id), { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = attachment.originalName || 'proof';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (e) {
    alert('Failed to download file');
  }
};

export const viewProof = async (attachment) => {
  try {
    const res = await axios.get(proofUrl(attachment._id), { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    alert('Failed to open file');
  }
};
